import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import HotSection from "./components/HotSection";
import LateNightSection from "./components/LateNightSection";
import GenreFilterSection from "./components/GenreFilterSection";
import ClassicSection from "./components/ClassicSection";
import DownloadSection from "./components/DownloadSection";
import ScheduleSection from "./components/ScheduleSection";
import StatsSection from "./components/StatsSection";
import GuideSection from "./components/GuideSection";
import FaqSection from "./components/FaqSection";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <HotSection />
        <LateNightSection />
        <GenreFilterSection />
        <ClassicSection />
        <DownloadSection />
        <ScheduleSection />
        <StatsSection />
        <GuideSection />
        <FaqSection />

        <section className="w-full bg-background-50 px-4 pb-16 md:px-8 md:pb-20">
          <div className="relative overflow-hidden rounded-lg border border-background-200 bg-secondary-900 px-6 py-10 md:px-12 md:py-12">
            <div className="pointer-events-none absolute -right-16 -top-16 h-64 w-64 rounded-full bg-accent-500/25 blur-3xl" />
            <div className="relative flex flex-col items-start gap-6 lg:flex-row lg:items-center lg:justify-between">
              <div className="max-w-2xl">
                <h2 className="font-heading text-3xl text-background-50 md:text-4xl">
                  现在就挑一部，开始你的追番节奏
                </h2>
                <p className="mt-3 text-sm leading-relaxed text-background-100/75">
                  在线看还是先下载都可以：进热门全集榜挑连载新番，或到经典补番区找一部完结好剧慢慢看。
                  深夜专区永远为你留着一盏灯。
                </p>
              </div>
              <div className="flex flex-col gap-3 sm:flex-row lg:shrink-0">
                <a
                  href="#hot"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
                >
                  <i className="ri-play-circle-line text-lg" />
                  在线观看入口
                </a>
                <a
                  href="#download"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/25 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10 cursor-pointer"
                >
                  <i className="ri-download-2-line text-lg" />
                  资源下载
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}